export default "__VITE_ASSET__a2607091__"